module.exports = __webpack_public_path__ + "b2ee965459d468c620760c74e124bdb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/0/Assets/graph2.png
// module id = 1316
// module chunks = 0